import {
  Injectable,
  EventEmitter
} from '@angular/core';
import {
  Observable
} from 'rxjs';
import {
  HttpClient
} from "../utility/http.client";



@Injectable()
export class UserService {
  refreshHeaderData: EventEmitter < any > = new EventEmitter();


  constructor(
    private http: HttpClient
  ) {}

    reqResetPassword(data: any): Observable < any > {
      return this.http.post('/users/reqResetPassword', data);
    }

    verifyReSetPwdLink(data: any): Observable < any > {
      return this.http.post('/users/verifyReSetPwdLink', data);  
    }

    resetPassword(data: any): Observable < any > {
      return this.http.post('/users/resetPassword', data);
    }

    getUserProfile(data: any): Observable < any > {
      return this.http.get('/users/getCurrentUserProfile', data);
    }

    updateUserProfile(data: any): Observable < any > {
      return this.http.post('/users/updateUserProfile', data);
    }

    verifyGeneratePwdToken(data: any): Observable < any > {
      return this.http.post('/users/verifyGeneratePwdToken', data);  
    }
    createFirstPassword(data: any):  Observable < any > {
      return this.http.post('/users/createFirstPassword', data);  
    }
    getUserDetails(data : any): Observable < any > {
      return this.http.get('/users/getUserDetails/',data);      
    } 

    checkEmail(data : any ): Observable < any > {
      //console.log("checking email ")
      return this.http.post('/users/checkEmail/',data);            
    }

    addDescription(data: any):  Observable < any > {
      return this.http.post('/users/addDescription', data);  
    }
    
  }
